// extracted by mini-css-extract-plugin
export default {"tableHead":"TableHead_tableHead__el+Yn","sortable":"TableHead_sortable__p8qt1","shortTableHead":"TableHead_shortTableHead__eg0E+"};